import { z } from 'zod';

export class ValidatorService {
	static isValidPrompt(prompt: string) {
		return z.string().min(1).max(5000).safeParse(prompt).success;
	}

	static isValidId(id: string) {
		return z.string().uuid().safeParse(id).success;
	}
}
